import React from 'react';
import { TopToolbar, ExportButton, useListContext, FilterButton } from 'react-admin';
import UploadFileMultipleFilter from '../devices/Buttons/UploadFileMultipleFilter';
import UploadFileMassiveChiuso from './Buttons/UploadFileMassiveChiuso';
import UploadFileMassiveMagChange from './Buttons/UploadFileMassiveMagChange';

const DevicesDaEsaminareActions = () => {
    const { total,
        currentSort,
        exporter,
        filterValues,
        resource, } = useListContext();
    return (
        <TopToolbar>
            <UploadFileMultipleFilter />
            <FilterButton disableSaveQuery />
            <UploadFileMassiveChiuso />
            <UploadFileMassiveMagChange />
            <ExportButton
                disabled={total === 0}
                resource={resource}
                sort={currentSort}
                filter={filterValues}
                exporter={exporter}
                maxResults={30000}
            />
        </TopToolbar>
    )};

export default DevicesDaEsaminareActions;